export enum EPoolingLandingRequestNamePart {
  FETCH = 'poolingLanding_:id',
}
